import PlayIcon from "components/Icons/PlayIcon";
import { BlueLightFilterIcon, DistanceIcon, MultifocalIcon, NewColorIcon, NewPolorizeIcon, NewPreventIcon, NewUVIcon, ReadingClearIcon, ReadingEyeIcon, ReadingHeadacheIcon, ReadingIcon, ReadingPhoneIcon } from "components/Icons/ProductExplanationIcons";
import { ProductDetailProps } from "constants/dataTypes";
import { imageLoader } from "functions/imageLoader";
import dynamic from "next/dynamic";
import Image from "next/image";
import Link from "next/link";
import { useMemo, useState } from "react";
import parse from 'html-react-parser';
import { useGlassesStore } from "zus/glassesStore";
import { useRouter } from "next/router";
import PrescriptionAlt from "components/Icons/PrescriptionAlt";
import ShippingIcon from "components/Icons/ShippingIcon";
import ReturnIcon from "components/Icons/ReturnIcon";
import { nonPrescriptionShippingAndReturnContent, prescriptionShippingAndReturnContent } from "data/product-details.data";
import { useQueryState } from "nuqs";
const ReactPlayer = dynamic(() => import("react-player"), { ssr: false });


const FramesContent = ({ deviceType, content, title }: ProductDetailProps) => {
	const router = useRouter();
	const locale = router.locale;
	const contentWithModifiedLinks = (htmlContent: string) => {
		if (!htmlContent) return '';
		htmlContent = htmlContent.replace(/\n/g, '<br>');

		const selectedLocale = locale === 'international' ? '' : locale + '/';
		const options = {
			replace: (domNode: any) => {
				if (domNode.type === 'tag' && domNode.name === 'a') {
					const originalHref = domNode.attribs.href;
					if (originalHref.startsWith('https://dresden.vision/')
						&& !originalHref.includes('/au/')
						&& !originalHref.includes('/ca/')
						&& !originalHref.includes('/nz/')
					) {
						domNode.attribs.href = originalHref.replace('https://dresden.vision/', `https://dresden.vision/${selectedLocale}`);
					}
					domNode.attribs.class = 'text-[#00AEC7]';
				}
			}
		};
		return parse(htmlContent, options);
	};
	return deviceType?.isDesktop ?
		(
			<div className="flex justify-between w-full gap-8">
				<div className="flex flex-col gap-5 w-[45%] justify-top">
					<h2 className="font-semibold text-[40px] leading-[44px]"> {title} </h2>
					<p className="font-normal text-[16px] leading-[18px] text-[#2A2A2A] tracking-[0.02em]">
						{contentWithModifiedLinks(content!)}
					</p>
				</div>
				<div className="flex flex-col gap-[30px] w-[55%] justify-top items-top">
					<div className="flex gap-24">
						<div className="flex gap-4 min-w-[228px]">
							<div className="flex justify-center items-center w-[80px] h-[80px] bg-[#F5F5F5] rounded-md">
								<Image width={80} height={80} loading="lazy" decoding="async" src="/images/homepage/icons/icon_tenyearframewarranty@2x.png" alt="ten year warranty" />
							</div>
							<p className="flex items-center justify-center text-[16px] leading-[18px] font-medium">10 Year Warranty</p>
						</div>
						<div className="flex gap-4 min-w-[228px]">
							<div className="flex justify-center items-center w-[80px] h-[80px] bg-[#F5F5F5] rounded-md">
								<Image width={80} height={80} loading="lazy" decoding="async" src="/images/homepage/icons/icon_sustainable@2x.png" alt="ten year warranty" />
							</div>
							<p className="flex items-center justify-center text-[16px] leading-[18px] font-medium">Sustainable</p>
						</div>
					</div>
					<div className="flex gap-24">
						<div className="flex gap-4 min-w-[228px]">
							<div className="flex justify-center items-center w-[80px] h-[80px] bg-[#F5F5F5] rounded-md">
								<Image width={80} height={80} loading="lazy" decoding="async" src="/images/homepage/icons/icon_australiamap@2x.png" alt="ten year warranty" />
							</div>
							<p className="flex items-center justify-center text-[16px] leading-[18px] font-medium">Made in Australia</p>
						</div>
						<div className="flex gap-4 min-w-[228px]">
							<div className="flex justify-center items-center w-[80px] h-[80px] bg-[#F5F5F5] rounded-md">
								<Image width={80} height={80} loading="lazy" decoding="async" src="/images/homepage/icons/icon_mixmatch@2x.png" alt="ten year warranty" />
							</div>
							<p className="flex items-center justify-center text-[16px] leading-[18px] font-medium">Mix & match</p>
						</div>
					</div>
				</div>
			</div>
		) :
		(
			<div className="flex flex-col gap-[30px]">
				<p className="font-normal text-[16px] leading-[18px] text-[#2A2A2A] tracking-[0.02em]">
					{contentWithModifiedLinks(content!)}
				</p>
				<div className="flex flex-col gap-[40px]">
					<div className="flex justify-evenly gap-20">
						<div className="flex flex-col gap-[14px] items-center min-w-[115px]">
							<div className="flex justify-center items-center w-[80px] h-[80px] bg-[#F5F5F5] rounded-md">
								<Image width={80} height={80} loading="lazy" decoding="async" src="/images/homepage/icons/icon_tenyearframewarranty@2x.png" alt="ten year warranty" />
							</div>
							<p className="flex items-center justify-center font-medium text-[14px] leading-[15px]">10 Year Warranty</p>
						</div>
						<div className="flex flex-col gap-[14px] items-center min-w-[115px]">
							<div className="flex justify-center items-center w-[80px] h-[80px] bg-[#F5F5F5] rounded-md">
								<Image width={80} height={80} loading="lazy" decoding="async" src="/images/homepage/icons/icon_sustainable@2x.png" alt="ten year warranty" />
							</div>
							<p className="flex items-center justify-center font-medium text-[14px] leading-[15px]">Sustainable</p>
						</div>
					</div>
					<div className="flex justify-evenly gap-20">
						<div className="flex flex-col gap-[14px] items-center min-w-[115px]">
							<div className="flex justify-center items-center w-[80px] h-[80px] bg-[#F5F5F5] rounded-md">
								<Image width={80} height={80} loading="lazy" decoding="async" src="/images/homepage/icons/icon_australiamap@2x.png" alt="ten year warranty" />
							</div>
							<p className="flex items-center justify-center font-medium text-[14px] leading-[15px]">Made in Australia</p>
						</div>
						<div className="flex flex-col gap-[14px] items-center min-w-[115px]">
							<div className="flex justify-center items-center w-[80px] h-[80px] bg-[#F5F5F5] rounded-md">
								<Image width={80} height={80} loading="lazy" decoding="async" src="/images/homepage/icons/icon_mixmatch@2x.png" alt="ten year warranty" />
							</div>
							<p className="flex items-center justify-center font-medium text-[14px] leading-[15px]">Mix & match</p>
						</div>
					</div>
				</div>
			</div>
		)
}

const SizingContent = ({ frameSize, deviceType }: ProductDetailProps) => {

	const frameSizeZ = useGlassesStore((state) => state.frame_size);
	const [selectedFrame, setSelectedFrame] = useState(frameSize!);
	const [frameShapeQuery] = useQueryState('shape');
	const [unit, setUnit] = useState<'mm' | 'inches'>('mm');
	const size = useMemo(() => {

		if (selectedFrame == 'XS') {
			return "Extra Small"
		} else if (selectedFrame == 'S') {
			return "Small"
		} else if (selectedFrame == 'M') {
			return "Medium"
		} else if (selectedFrame == 'L') {
			return "Large"
		}

	}, [selectedFrame]);

	useMemo(() => {
		setSelectedFrame(frameSizeZ);
	}, [frameSizeZ]);

	return deviceType?.isDesktop ?
		(
			<div className="flex justify-between w-full gap-16">
				<div className="flex flex-col gap-5 w-[45%]">
					<h2 className="font-semibold text-[40px] leading-[44px]"> Fit & Sizing </h2>
					<div className="">
						<p className="tracking-[0.02em] text-[#2A2A2A]"> Our frame parts are modular and can be mixed easily. </p>
						<p className=""> Please use this table as a guide to sizing. </p>
					</div>

					<div className="mt-[16px] ">
						<div className="flex items-center gap-2 mb-4 ">
							<span className={`text-sm ${unit === 'mm' ? 'text-[#2A2A2A]' : 'text-[#757575]'}`}>mm</span>
							<button
								onClick={() => setUnit(unit === 'mm' ? 'inches' : 'mm')}
								className="relative inline-flex h-6 w-11 items-center rounded-full bg-[#D9F3F7] h-[31px] w-[56px]"
								role="switch"
								aria-checked={unit === 'inches'}
							>
								<span
									className={`${unit === 'inches' ? 'translate-x-7 ' : 'translate-x-1 '
										} inline-block h-[23px] w-[23px] transform rounded-full transition duration-200 ease-in-out shadow-sm bg-[#00AEC7]`}
								/>
							</button>
							<span className={`text-sm ${unit === 'inches' ? 'text-[#2A2A2A]' : 'text-[#757575]'}`}>inches</span>
						</div>
					</div>

					<div className="">
						<p className=""> Size: <span className="font-medium"> {size} </span> </p>
					</div>
					<div className="flex gap-[10px]">
						{frameShapeQuery !== 'round' && (<button onClick={() => setSelectedFrame('XS')} className={`rounded-md border border-solid border-[#CACACA] py-[12px] px-[16px] ${selectedFrame === 'XS' ? 'bg-[#FF8200]' : ""}`}>
							<p className={`min-w-[20px] font-medium ${selectedFrame === 'XS' ? 'text-white' : 'text-[#616161]'}`}> XS </p>
						</button>)}
						<button onClick={() => setSelectedFrame('S')} className={`rounded-md border border-solid border-[#CACACA] py-[12px] px-[16px] ${selectedFrame === 'S' ? 'bg-[#FF8200]' : ""}`}>
							<p className={`min-w-[20px] font-medium ${selectedFrame === 'S' ? 'text-white' : 'text-[#616161]'}`}> S </p>
						</button>
						<button onClick={() => setSelectedFrame('M')} className={`rounded-md border border-solid border-[#CACACA] py-[12px] px-[16px] ${selectedFrame === 'M' ? 'bg-[#FF8200]' : ""}`}>
							<p className={`min-w-[20px] font-medium ${selectedFrame === 'M' ? 'text-white' : 'text-[#616161]'}`}> M </p>
						</button>
						<button onClick={() => setSelectedFrame('L')} className={`rounded-md border border-solid border-[#CACACA] py-[12px] px-[16px] ${selectedFrame === 'L' ? 'bg-[#FF8200]' : ""}`}>
							<p className={`min-w-[20px] font-medium ${selectedFrame === 'L' ? 'text-white' : 'text-[#616161]'}`}> L </p>
						</button>
					</div>
					<a target="_blank" rel="noopener noreferrer" href="https://cdn.dresden.vision/docs/dresden-frame-scaled-size-guide-2025.pdf" className="mt-[20px] gap-2 flex">
						<p className="font-medium text-base leading-[18px] text-[#00AEC7] tracking-[0.02em]"> Not sure about your size? </p>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none" className="self-end">
							<path fillRule="evenodd" clipRule="evenodd" d="M15.6272 7.07107L15.6265 7.07031L14.0708 5.51468L8.55615 0L7.00052 1.55564L11.4449 6H0V8H11.5855L6.99976 12.5857L8.55539 14.1414L14.0708 8.62595L14.0716 8.62671L15.6272 7.07107Z" fill="#00AEC7" />
						</svg>
					</a>
				</div>
				<div className="flex flex-col gap-5 w-[55%] items-center relative">
					<div className="w-full h-full">
						<div className="w-[561px] h-[336px] relative">
							<Image
								src={`/images/frame_sizes/${unit === 'mm' ? 'mm' : 'inches'}/${frameShapeQuery === 'round' ? 'capote' : 'original'}_${selectedFrame.toLocaleLowerCase()}.png`}
								width={500}
								height={300}
								objectFit="cover"
								alt={'XSmall Fit & Sizing'}
							/>
						</div>
					</div>
				</div>
			</div >
		) :
		(
			<div className="flex flex-col gap-[20px]">
				<p className="font-normal text-[16px] leading-[18px] text-[#2A2A2A] tracking-[0.02em]">
					Dresden frames come in 4 standard sizes - Large, Medium, Small and Extra Small. All parts are modular and interchangeable so you can select your frame front size, and your arm length for the perfect fit.
				</p>

				<div className="mt-[16px] ">
					<div className="flex items-center gap-2 mb-4 ">
						<span className={`text-sm ${unit === 'mm' ? 'text-[#2A2A2A]' : 'text-[#757575]'}`}>mm</span>
						<button
							onClick={() => setUnit(unit === 'mm' ? 'inches' : 'mm')}
							className="relative inline-flex h-6 w-11 items-center rounded-full bg-[#D9F3F7] h-[31px] w-[56px]"
							role="switch"
							aria-checked={unit === 'inches'}
						>
							<span
								className={`${unit === 'inches' ? 'translate-x-7 ' : 'translate-x-1 '
									} inline-block h-[23px] w-[23px] transform rounded-full transition duration-200 ease-in-out shadow-sm bg-[#00AEC7]`}
							/>
						</button>
						<span className={`text-sm ${unit === 'inches' ? 'text-[#2A2A2A]' : 'text-[#757575]'}`}>inches</span>
					</div>
				</div>

				<p className=""> Size: <span className="font-medium"> {size} </span> </p>
				<div className="flex gap-[10px]">
					{frameShapeQuery !== 'round' && (<button onClick={() => setSelectedFrame('XS')} className={`rounded-md border border-solid border-[#CACACA] py-[11px] px-[15px] ${selectedFrame === 'XS' ? 'bg-[#FF8200]' : ""}`}>
						<p className={`min-w-[20px] font-medium ${selectedFrame === 'XS' ? 'text-white' : 'text-[#616161]'}`}> XS </p>
					</button>)}
					<button onClick={() => setSelectedFrame('S')} className={`rounded-md border border-solid border-[#CACACA] py-[11px] px-[15px] ${selectedFrame === 'S' ? 'bg-[#FF8200]' : ""}`}>
						<p className={`min-w-[20px] font-medium ${selectedFrame === 'S' ? 'text-white' : 'text-[#616161]'}`}> S </p>
					</button>
					<button onClick={() => setSelectedFrame('M')} className={`rounded-md border border-solid border-[#CACACA] py-[11px] px-[15px] ${selectedFrame === 'M' ? 'bg-[#FF8200]' : ""}`}>
						<p className={`min-w-[20px] font-medium ${selectedFrame === 'M' ? 'text-white' : 'text-[#616161]'}`}> M </p>
					</button>
					<button onClick={() => setSelectedFrame('L')} className={`rounded-md border border-solid border-[#CACACA] py-[11px] px-[15px] ${selectedFrame === 'L' ? 'bg-[#FF8200]' : ""}`}>
						<p className={`min-w-[20px] font-medium ${selectedFrame === 'L' ? 'text-white' : 'text-[#616161]'}`}> L </p>
					</button>
				</div>
				<div className="flex justify-start">
					<div className="w-[335px] h-[259px] relative">
						<Image
							src={`/images/frame_sizes/${unit === 'mm' ? 'mm' : 'inches'}/${frameShapeQuery === 'round' ? 'capote' : 'original'}_${selectedFrame.toLocaleLowerCase()}.png`}
							width={500}
							height={300}
							objectFit="cover"
							alt={'XSmall Fit & Sizing'}
						/>
					</div>
				</div>
				<a target="_blank" rel="noopener noreferrer" href="https://dresden.vision/assets/Pdfs/dresden-frame-scaled-size-guide-2021.pdf" className="mt-[20px] gap-2 flex">
					<p className="font-medium text-base leading-[18px] text-[#00AEC7] tracking-[0.02em]"> Not sure about your size? </p>
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none" className="self-end">
						<path fillRule="evenodd" clipRule="evenodd" d="M15.6272 7.07107L15.6265 7.07031L14.0708 5.51468L8.55615 0L7.00052 1.55564L11.4449 6H0V8H11.5855L6.99976 12.5857L8.55539 14.1414L14.0708 8.62595L14.0716 8.62671L15.6272 7.07107Z" fill="#00AEC7" />
					</svg>
				</a>
			</div>
		)
}

const LensesContentDresdengo = ({ content, deviceType, locale }: ProductDetailProps) => {


	const contentWithModifiedLinks = (htmlContent: string) => {
		htmlContent = htmlContent.replace(/\n/g, '<br>');

		const selectedLocale = locale === 'international' ? '' : locale + '/';
		const options = {
			replace: (domNode: any) => {
				if (domNode.type === 'tag' && domNode.name === 'a') {
					const originalHref = domNode.attribs.href;
					if (originalHref.startsWith('https://dresden.vision/')
						&& !originalHref.includes('/au/')
						&& !originalHref.includes('/ca/')
						&& !originalHref.includes('/nz/')
					) {
						domNode.attribs.href = originalHref.replace('https://dresden.vision/', `https://dresden.vision/${selectedLocale}`);
					}
					domNode.attribs.class = 'text-[#00AEC7]';
				}
			}
		};
		return parse(htmlContent, options);
	};

	return deviceType?.isDesktop ?
		(
			<div className="flex justify-between w-full gap-8">
				<div className="flex flex-col gap-5 w-full justify-top">
					<h2 className="font-semibold text-[40px] leading-[44px]"> Lenses </h2>
					<p className="font-normal text-[16px] leading-[18px] text-[#2A2A2A] tracking-[0.02em]">
						{contentWithModifiedLinks(content!)}
					</p>
				</div>
			</div>
		) :
		(
			<div className="flex flex-col gap-[30px]">
				<p className="font-normal text-[16px] leading-[18px] text-[#2A2A2A] tracking-[0.02em]">
					{contentWithModifiedLinks(content!)}
				</p>
			</div>
		)
}

const LensesContent = ({ content, deviceType, locale }: ProductDetailProps) => {
	const router = useRouter();

	const contentWithModifiedLinks = (htmlContent: string) => {
		if (!htmlContent) return '';

		htmlContent = htmlContent.replace(/\n/g, '<br>');

		const selectedLocale = locale === 'international' ? '' : locale + '/';
		const options = {
			replace: (domNode: any) => {
				if (domNode.type === 'tag' && domNode.name === 'a') {
					const originalHref = domNode.attribs.href;
					if (originalHref.startsWith('https://dresden.vision/')
						&& !originalHref.includes('/au/')
						&& !originalHref.includes('/ca/')
						&& !originalHref.includes('/nz/')
					) {
						domNode.attribs.href = originalHref.replace('https://dresden.vision/', `https://dresden.vision/${selectedLocale}`);
					}
					domNode.attribs.class = 'text-[#00AEC7]';
				}
			}
		};
		return parse(htmlContent, options);
	};


	const features: any = {
		'non-prescription-sunglasses': [
			{
				icon: <NewUVIcon />,
				name: 'UV protection',
			},
			{
				icon: <NewPolorizeIcon />,
				name: 'Polarised options',
			},
			{
				icon: <NewColorIcon />,
				name: 'Colour choices',
			},
			{
				icon: <NewPreventIcon />,
				name: 'Prevent glares',
			},
		],
		'sunglasses': [
			{
				icon: <NewUVIcon />,
				name: 'UV protection',
			},
			{
				icon: <NewPolorizeIcon />,
				name: 'Polarised options',
			},
			{
				icon: <NewColorIcon />,
				name: 'Colour choices',
			},
			{
				icon: <NewPreventIcon />,
				name: 'Prevent glares',
			},
		],
		'reading-glasses': [
			{
				icon: <ReadingEyeIcon />,
				name: 'Reduce digital <br> eye strain',
			},
			{
				icon: <ReadingHeadacheIcon />,
				name: 'Lens headaches <br>& sore eyes',
			},
			{
				icon: <ReadingClearIcon />,
				name: 'Virtually <br> clear lens',
			},
			{
				icon: <ReadingPhoneIcon />,
				name: 'Filter blue light <br> from screen',
			},
		],
		'blue-light-filter-glasses': [
			{
				icon: <ReadingEyeIcon />,
				name: 'Reduce digital <br> eye strain',
			},
			{
				icon: <ReadingHeadacheIcon />,
				name: 'Lens headaches <br> & sore eyes',
			},
			{
				icon: <ReadingClearIcon />,
				name: 'Virtually <br>clear lens',
			},
			{
				icon: <ReadingPhoneIcon />,
				name: 'Filter blue light <br> from screen',
			},
		],
		'default': [
			{
				icon: <DistanceIcon width={54} height={48} />,
				name: 'Single Vision Distance',
			},
			{
				icon: <MultifocalIcon width={58} height={36} />,
				name: 'Progressive Lenses',
			},
			{
				icon: <ReadingIcon width={54} height={50} />,
				name: 'Single Vision Reading',
			},
			{
				icon: <BlueLightFilterIcon width={54} height={51} />,
				name: 'Blue Light Filter',
			},
		],
	};

	const type = router.asPath.split('/')[2];

	const selectedFeatures = features[type] || features['default'];

	// Group features into pairs
	const featurePairs = [];
	for (let i = 0; i < selectedFeatures.length; i += 2) {
		featurePairs.push(selectedFeatures.slice(i, i + 2));
	}

	return deviceType?.isDesktop ?
		(
			<div className="flex justify-between w-full gap-8">
				<div className="flex flex-col gap-5 w-[45%] justify-top">
					<h2 className="font-semibold text-[40px] leading-[44px]"> Lenses </h2>
					<p className="font-normal text-[16px] leading-[18px] text-[#2A2A2A] tracking-[0.02em]">
						{contentWithModifiedLinks(content!)}
					</p>
				</div>
				<div className="flex flex-col gap-[30px] w-[55%] justify-top items-center">
					{featurePairs.map((pair, index) => (
						<div key={index} className="flex gap-12">
							{pair.map((feature: any, subIndex: any) => (
								<div key={subIndex} className="flex  min-w-[266px]">
									<div className="flex justify-center items-center w-[80px] h-[80px] bg-[#F5F5F5] rounded-md">
										{feature.icon}
									</div>
									<p className="flex ml-[16px] items-center justify-center text-[16px] leading-[18px] font-medium"
										dangerouslySetInnerHTML={{ __html: feature.name }}>
									</p>
								</div>
							))}
						</div>
					))}
				</div>
			</div>
		) :
		(
			<div className="flex flex-col gap-[30px]">
				<p className="font-normal text-[16px] leading-[18px] text-[#2A2A2A] tracking-[0.02em]">
					{contentWithModifiedLinks(content!)}
				</p>
				<div className="flex flex-col gap-[40px]">
					{featurePairs.map((pair, index) => (
						<div className="flex justify-evenly gap-20" key={index}>
							{pair.map((feature: any, subIndex: any) => (
								<div key={subIndex} className="flex flex-col gap-[14px] items-center min-w-[87px]">
									<div className="flex justify-center items-center w-[80px] h-[80px] bg-[#F5F5F5] rounded-md">
										{feature.icon}
									</div>
									<p className="flex items-center justify-center font-medium text-[14px] leading-[15px] text-center w-[125px]"
										dangerouslySetInnerHTML={{ __html: feature.name }}>
									</p>
								</div>
							))}
						</div>
					))}
				</div>
			</div>
		)
}


const WhatsInTheBoxContent = ({ deviceType }: ProductDetailProps) => {

	const [frameShapeQuery] = useQueryState('shape');
	return deviceType?.isDesktop ?
		(
			<div className="flex justify-between w-full h-full">
				<div className="flex flex-col gap-5 w-[45%] justify-start">
					<h2 className="text-[40px] leading-[44px] font-semibold"> {'What\'s in the Box'} </h2>
					<p className="text-[#2A2A2A] tracking-[0.02em]"> Your new glasses will arrive in a simple environmentally friendly box including extra pins and a 100% recycled micro-fibre lens cloth. </p>
					<p className="text-[#2A2A2A] tracking-[0.02em]"> A little extra love for your specs is easy done with our range of colourful cases, cleaning gear and other eye-care products. </p>
					<div className="flex">
						<div className="flex cursor-pointer gap-2">
							<Link prefetch={false} href="/shop/accessories" className="flex items-center">

								<p className="font-medium text-base leading-[18px] text-[#00AEC7] tracking-[0.02em] mr-2"> Browse the range here </p>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none" className="self-end">
									<path fillRule="evenodd" clipRule="evenodd" d="M15.6272 7.07107L15.6265 7.07031L14.0708 5.51468L8.55615 0L7.00052 1.55564L11.4449 6H0V8H11.5855L6.99976 12.5857L8.55539 14.1414L14.0708 8.62595L14.0716 8.62671L15.6272 7.07107Z" fill="#00AEC7" />
								</svg>

							</Link>
						</div>

					</div>
				</div>
				<div className="flex flex-col gap-5 w-[55%] relative items-center justify-start">
					<div className="w-[500px] h-[308px] relative">
						<Image
							src={`https://w.dresden.vision/images/whats_in_the_box_desktop${frameShapeQuery === 'round' ? '_round' : ''}.png`}
							fill
							key={frameShapeQuery ?? 'classic'}
							loader={imageLoader}
							style={{
								objectFit: "cover",
							}}
							sizes="500px"
							alt={"What's in the box?"}
						/>
					</div>
				</div>
			</div>
		) :
		(
			<div className="flex flex-col gap-[30px]">
				<p className="text-[#2A2A2A] tracking-[0.02em] leading-[18px]"> Your new glasses will arrive in a simple environmentally friendly box including extra pins and a 100% recycled micro-fibre lens cloth. A little extra love for your specs is easy done with our range of colourful cases, cleaning gear and other eye-care products. </p>
				<div className="flex">
					<Link prefetch={false} href="/shop/accessories" passHref legacyBehavior>
						<div className="gap-2 flex cursor-pointer">
							<p className="font-medium text-base leading-[18px] text-[#00AEC7] tracking-[0.02em]"> Browse the range here </p>

							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none" className="self-end">
								<path fillRule="evenodd" clipRule="evenodd" d="M15.6272 7.07107L15.6265 7.07031L14.0708 5.51468L8.55615 0L7.00052 1.55564L11.4449 6H0V8H11.5855L6.99976 12.5857L8.55539 14.1414L14.0708 8.62595L14.0716 8.62671L15.6272 7.07107Z" fill="#00AEC7" />
							</svg>
						</div>
					</Link>
				</div>
				<div className="flex justify-start">
					<div className="w-[345px] h-[212px] relative">
						<Image
							src={`https://w.dresden.vision/images/whats_in_the_box_desktop${frameShapeQuery === 'round' ? '_round' : ''}.png`}
							loader={imageLoader}
							fill
							key={frameShapeQuery ?? 'classic'}
							style={{
								objectFit: "cover",
							}}
							sizes="345px"
							alt={"What's in the box?"}
						/>
					</div>
				</div>
			</div>
		);
}

const CustomizeContent = ({ deviceType, locale }: ProductDetailProps) => {

	const [play, setPlay] = useState(false);

	return deviceType?.isDesktop ? (
		<div className="flex justify-between w-full h-full">
			<div className="flex flex-col gap-5 justify-top w-1/2">
				<h2 className="text-[40px] leading-[44px] font-semibold"> {
					locale === "ca" ?
						'Customize your frames' : 'Customise your frames'
				}
				</h2>
				<p className="text-[#2A2A2A] tracking-[0.02em]"> Be bold, never boring! Mix and match your frames with unlimited combinations, and stand out in a crowd. Select your frame front using our ‘Virtual Try On’, and then get experimental with your arm colours.
					<br /> One combo is never enough - add extra sets of arms to your basket. </p>
				<Link prefetch={false} href="/shop/spare-parts" passHref legacyBehavior>
					<div className="gap-2 flex cursor-pointer">
						<p className="font-medium text-base leading-[18px] text-[#00AEC7] tracking-[0.02em]"> Add extra set of arms </p>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none" className="self-end">
							<path fillRule="evenodd" clipRule="evenodd" d="M15.6272 7.07107L15.6265 7.07031L14.0708 5.51468L8.55615 0L7.00052 1.55564L11.4449 6H0V8H11.5855L6.99976 12.5857L8.55539 14.1414L14.0708 8.62595L14.0716 8.62671L15.6272 7.07107Z" fill="#00AEC7" />
						</svg>
					</div>
				</Link>
			</div>
			<div className="flex justify-center items-start">
				<ReactPlayer
					width={'505px'}
					height={'261px'}
					url={"https://cdn.dresden.vision/video/desktop_customize_video.mp4"}
					light={'https://cdn.dresden.vision/images/desktop_customize_thumbnail.png'}
					controls
					playIcon={
						<div onClick={() => setPlay(true)} className="bg-[#00AEC7] rounded-full py-[23px] pr-[23px] pl-[28px]">
							<PlayIcon width={30} height={34} />
						</div>
					}
					playing={play}
					muted
				/>
			</div>
		</div>
	) :
		(
			<div className="flex flex-col gap-[30px]">
				<p className="text-[#2A2A2A] tracking-[0.02em] leading-[18px]"> Be bold, never boring! Mix and match your frames with unlimited combinations, and stand out in a crowd. Select your frame front using our ‘Virtual Try On’, and then get experimental with your arm colours. One combo is never enough - add extra sets of arms to your basket here. </p>
				<Link prefetch={false} href="/shop/spare-parts" passHref legacyBehavior>
					<div className="gap-2 flex cursor-pointer">
						<p className="font-medium text-base leading-[18px] text-[#00AEC7] tracking-[0.02em]"> Add extra set of arms </p>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none" className="self-end">
							<path fillRule="evenodd" clipRule="evenodd" d="M15.6272 7.07107L15.6265 7.07031L14.0708 5.51468L8.55615 0L7.00052 1.55564L11.4449 6H0V8H11.5855L6.99976 12.5857L8.55539 14.1414L14.0708 8.62595L14.0716 8.62671L15.6272 7.07107Z" fill="#00AEC7" />
						</svg>
					</div>
				</Link>
				<div className="flex justify-center items-center">
					<ReactPlayer
						width={'345px'}
						height={'178px'}
						light={'https://cdn.dresden.vision/images/mobile_customize_thumbnail.png'}
						url={"https://cdn.dresden.vision/video/mobile_customize_video.mp4"}
						controls
						playIcon={
							<div onClick={() => setPlay(true)} className="bg-[#00AEC7] rounded-full py-[23px] pr-[23px] pl-[28px]">
								<PlayIcon width={30} height={34} />
							</div>
						}
						playing={play}
						muted
					/>
				</div>
			</div>
		);
}

const ColorInspirationContent = ({ title, content, deviceType }: ProductDetailProps) => {

	if (title == null || title == "") {
		return <></>
	}

	return deviceType?.isDesktop ? (
		<div className="flex justify-between w-full gap-8">
			<div className="flex flex-col gap-5 justify-top">
				<h2 className="font-semibold text-[40px] leading-[44px]"> {title} </h2>
				<p className="font-normal text-[16px] leading-[18px] text-[#2A2A2A] tracking-[0.02em]">
					{content}
				</p>
			</div>
		</div>
	) :
		(
			<div className="flex flex-col">
				<p className="font-normal text-[16px] leading-[18px] text-[#2A2A2A] tracking-[0.02em]">
					{content}
				</p>
			</div>
		)
}

const WhatsInTheBoxGoContentReadingGlasses = ({ deviceType }: ProductDetailProps) => {
	const [frameShapeQuery] = useQueryState('shape');
	return deviceType?.isDesktop ? (<>

		<div className="flex lgx:flex-col justify-between w-full h-full ">

			<div className="px-2">
				<h2 className="text-[40px] mb-6 leading-[44px] font-semibold"> {'What\'s in the Box'} </h2>
				<ul className="list-disc text-base leading-10 ml-8">
					<li>Your pair of DresdenGO Readers (of course!)</li>

					<li>100% recycled felt glasses case</li>

					<li>Extra set of arms to mix and match</li>

					<li>Extra pins</li>

					<li>100% recycled cleaning cloth</li>
				</ul>
			</div>
			<div className="flex flex-col gap-5 w-[55%] relative items-center justify-end">
				<div className="w-[500px] h-[488px] relative mt-6">
					<Image
						src={`https://cdn.dresden.vision/images/WIB${frameShapeQuery === 'round' ? '_round' : ''}.webp`}
						fill
						style={{
							objectFit: "contain",
						}}
						sizes="500px"
						loader={imageLoader}
						alt={"What's in the box?"}
					/>
				</div>
			</div>
		</div>
	</>) : (<div className="w-full">
		<div className="flex w-full h-64 relative justify-start">
			<Image
				src={`https://cdn.dresden.vision/images/WIB${frameShapeQuery === 'round' ? '_round' : ''}.webp`}
				width={250}
				height={250}
				sizes="500px"
				className="ml-8"
				loader={imageLoader}
				alt={"What's in the box?"}
			/>
		</div>
		<ul className="list-disc text-base leading-10 ml-8">
			<li>Your pair of DresdenGO Blue Light (of course!)</li>

			<li>100% recycled felt glasses case</li>

			<li>Extra set of arms to mix and match</li>

			<li>Extra pins</li>

			<li>100% recycled cleaning cloth</li>
		</ul>

	</div>)
}
const WhatsInTheBoxGoContentBlueLight = ({ deviceType }: ProductDetailProps) => {

	const [frameShapeQuery] = useQueryState('shape');
	return deviceType?.isDesktop ? (<>

		<div className="flex lgx:flex-col justify-between w-full h-full ">

			<div className="px-2">
				<h2 className="text-[40px] mb-6 leading-[44px] font-semibold"> {'What\'s in the Box'} </h2>
				<ul className="list-disc text-base leading-10 ml-8">
					<li>Your pair of DresdenGO Blue Light (of course!)</li>

					<li>100% recycled felt glasses case</li>

					<li>Extra set of arms to mix and match</li>

					<li>Extra pins</li>

					<li>100% recycled cleaning cloth</li>
				</ul>
			</div>
			<div className="flex flex-col gap-5 w-[55%] relative items-center justify-end">
				<div className="w-[500px] h-[488px] relative  mt-6">
					<Image
						src={`https://cdn.dresden.vision/images/WIB${frameShapeQuery === 'round' ? '_round' : ''}.webp`}
						fill
						key={frameShapeQuery ?? 'classic'}
						style={{
							objectFit: "contain",
						}}
						sizes="500px"
						loader={imageLoader}
						alt={"What's in the box?"}
					/>
				</div>
			</div>
		</div>
	</>) : (<div className="w-full">
		<div className="w-full h-64 relative">
			<Image
				src={`https://cdn.dresden.vision/images/WIB${frameShapeQuery === 'round' ? '_round' : ''}.webp`}
				fill
				key={frameShapeQuery ?? 'classic'}
				style={{
					objectFit: "contain",
				}}
				sizes="500px"
				loader={imageLoader}
				alt={"What's in the box?"}
			/>
		</div>
		<ul className="list-disc text-base leading-10 ml-8">
			<li>Your pair of DresdenGO Blue Light (of course!)</li>

			<li>100% recycled felt glasses case</li>

			<li>Extra set of arms to mix and match</li>

			<li>Extra pins</li>

			<li>100% recycled cleaning cloth</li>
		</ul>

	</div>)
}

const WhatsInTheBoxGoContentNonRxSunglasses = ({ deviceType }: ProductDetailProps) => {

	const [frameShapeQuery] = useQueryState('shape');
	return deviceType?.isDesktop ? (<>

		<div className="flex lgx:flex-col justify-between w-full h-full relative">

			<div className="px-2">
				<h2 className="text-[40px] mb-6 leading-[44px] font-semibold"> {'What\'s in the Box'} </h2>
				<ul className="list-disc text-base leading-10 ml-8">
					<li>Your new DresdenGO polarised sunglasses (of course!)</li>

					<li>100% recycled felt glasses case</li>

					<li>Extra set of arms to mix and match</li>

					<li>Extra pins</li>

					<li>100% recycled cleaning cloth</li>
				</ul>
			</div>
			<div className="flex flex-col gap-5 w-[55%] relative items-center justify-end">
				<div className="w-[500px] h-[688px] relative mt-6">
					<Image
						src={`https://cdn.dresden.vision/images/WIB${frameShapeQuery === 'round' ? '_round' : ''}.webp`}
						fill
						key={frameShapeQuery ?? 'classic'}
						style={{
							objectFit: "contain",
						}}
						sizes="500px"
						loader={imageLoader}
						alt={"What's in the box?"}
					/>
				</div>
			</div>
		</div>
	</>) : (<div className="w-full">
		<div className="w-full h-64 relative">
			<Image
				src={`https://cdn.dresden.vision/images/WIB${frameShapeQuery === 'round' ? '_round' : ''}.webp`}
				fill
				key={frameShapeQuery ?? 'classic'}
				style={{
					objectFit: "contain",
				}}
				sizes="500px"
				loader={imageLoader}
				alt={"What's in the box?"}
			/>
		</div>
		<ul className="list-disc text-base leading-10 ml-8">
			<li>Your new DresdenGO polarised sunglasses (of course!)</li>

			<li>100% recycled felt glasses case</li>

			<li>Extra set of arms to mix and match</li>

			<li>Extra pins</li>

			<li>100% recycled cleaning cloth</li>
		</ul>

	</div>)
}


const ShippingAndReturn = ({ locale, path }: ProductDetailProps) => {
	const isPrescriptionGlasses = path?.includes('prescription-glasses') || path?.includes('/prescription-sunglasses');
	const { prescription, shipping, returns } = useMemo(() => {
		if (isPrescriptionGlasses) {
			return prescriptionShippingAndReturnContent[locale ? locale : 'international'];
		}
		return nonPrescriptionShippingAndReturnContent[locale ? locale : 'international'];
	}, [locale]);

	return (
		<div>
			<ul>
				{isPrescriptionGlasses && (
					<li className="mb-10 mt-8">
						<div className="flex">
							<div className="w-[80px] h-[80px] min-w-[80px] bg-[#F5F5F5] mr-6 rounded-lg flex items-center">
								<PrescriptionAlt className="mx-auto" />
							</div>
							<div className="text-base leading-5 text-brand-grey300">
								<div className="text-lg font-medium text-black mb-1 -top-1">{prescription.title}</div>
								<span dangerouslySetInnerHTML={{ __html: prescription.description }} />
							</div>
						</div>
					</li>
				)}
				<li className="mb-10 mt-8">
					<div className="flex">
						<div className="w-[80px] h-[80px] min-w-[80px] bg-[#F5F5F5] mr-6 rounded-lg flex items-center">
							<ShippingIcon className="mx-auto" />
						</div>
						<div className="text-base leading-5 text-brand-grey300">
							<div className="text-lg font-medium text-black mb-1 -top-1">{shipping.title}</div>
							<span dangerouslySetInnerHTML={{ __html: shipping.description }} />
						</div>
					</div>
				</li>
				<li className="mb-2 mt-8">
					<div className="flex">
						<div className="w-[80px] h-[80px] min-w-[80px] bg-[#F5F5F5] mr-6 rounded-lg flex items-center">
							<ReturnIcon className="mx-auto" />
						</div>
						<div className="text-base leading-5 text-brand-grey300">
							<div className="text-lg font-medium text-black mb-1 -top-1">{returns.title}</div>
							<span dangerouslySetInnerHTML={{ __html: returns.description }} />
						</div>
					</div>
				</li>
			</ul>
		</div>
	);
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	FramesContent,
	SizingContent,
	LensesContent,
	LensesContentDresdengo,
	WhatsInTheBoxContent,
	WhatsInTheBoxGoContentNonRxSunglasses,
	WhatsInTheBoxGoContentReadingGlasses,
	WhatsInTheBoxGoContentBlueLight,
	CustomizeContent,
	ColorInspirationContent,
	ShippingAndReturn
};